module.exports = __webpack_public_path__ + "media/images/icon-change-8faa67517003fa8fd59e834a5ff99798.svg";